import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { Copy, Link } from 'lucide-react'
import { useCopyToClipboard } from '../hooks/use-copy-to-clipboard'

/**
 * A link in a row, with the orange "Copy link" button: the same row in every window that shares a link, as the
 * prototype draws it (link icon, the URL, copy icon on the button).
 */
export function CopyLinkRow({
  url,
  label,
  copiedLabel,
}: {
  url: string
  label: string
  copiedLabel: string
}) {
  const { copied, copy } = useCopyToClipboard()
  return (
    <div className="flex items-center gap-2 rounded-lg bg-[#0F0F10] p-1.5 pl-3">
      <Link className="size-4 shrink-0 text-muted-foreground" aria-hidden />
      <span className="min-w-0 flex-1 truncate text-sm text-foreground/80">{url}</span>
      <CtaButton size="sm" icon={<Copy />} onClick={() => copy(url)} className="shrink-0">
        {copied ? copiedLabel : label}
      </CtaButton>
    </div>
  )
}
